import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { OverlayLoader, Spin } from 'components';

import { ITitledInfoBlockProps } from './TitledInfoBlock.types';

import './TitledInfoBlock.styles.scss';

const { Text } = Typography;

const TitledInfoBlock = ({
  title,
  children,
  loading,
  isOverlayLoading,
  block,
  titleRightComponent,
  titleLeftComponent,
}: ITitledInfoBlockProps) => {
  const { t } = useTranslation();

  const flex = block ? '1' : null;
  const width = block ? '100%' : null;

  return (
    <div className="np-titled-info-block" style={{ flex, width }}>
      <div className="np-titled-info-block__header">
        <div className="np-titled-info-block__header-title-wrapper">
          <Text className="np-titled-info-block__header-title">{t(title)}</Text>
          {titleLeftComponent}
        </div>

        {titleRightComponent}
      </div>

      <div className="np-titled-info-block__body">
        {loading && isOverlayLoading && <OverlayLoader borderRadius="0 0 16px 16px" />}

        {loading && !isOverlayLoading && <Spin size="default" />}

        {(!loading || (loading && isOverlayLoading)) && children}
      </div>
    </div>
  );
};

export default TitledInfoBlock;
